import {
  INTEREST_DIRECTION_HELPER,
  INTEREST_DIRECTION_LABEL,
  INTEREST_DIRECTION_SEGMENTS,
} from "./constants";
import {
  Field,
  FieldError,
  FieldHelper,
  FieldLabel,
  LabelRow,
  ToneSegments,
} from "../../../components/FormPanel";
import { InterestDirectionFieldProps } from "./types";

// Driven by `setValue` rather than registered, so no input renders its error: this is the one place
// a server "Direction …" message can surface instead of landing in an invisible sink.
export const InterestDirectionField = ({
  value,
  groupLabel,
  isSubmitting,
  error,
  onChange,
}: InterestDirectionFieldProps) => (
  <Field>
    <LabelRow>
      <FieldLabel>{INTEREST_DIRECTION_LABEL}</FieldLabel>
    </LabelRow>
    <ToneSegments
      groupLabel={groupLabel}
      options={INTEREST_DIRECTION_SEGMENTS}
      selectedValue={value}
      disabled={isSubmitting}
      onChange={(segment) => onChange(segment.value)}
    />
    <FieldHelper>{INTEREST_DIRECTION_HELPER}</FieldHelper>
    {error && <FieldError role="alert">{error}</FieldError>}
  </Field>
);
